var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBBoxArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-box-archive",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-box-archive1",
    serifid: "iconB-box-archive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M21,8.829l0,7.371c0,1.925 -0.061,2.881 -0.436,3.616c-0.383,0.753 -0.995,1.365 -1.748,1.748c-0.735,0.375 -1.691,0.436 -3.616,0.436l-6.4,0c-1.925,0 -2.881,-0.061 -3.616,-0.436c-0.753,-0.383 -1.365,-0.995 -1.748,-1.748c-0.375,-0.735 -0.436,-1.691 -0.436,-3.616l0,-7.371c-0.988,-0.349 -1.734,-1.196 -1.942,-2.244c-0.047,-0.235 -0.058,-0.518 -0.058,-1.085c0,-0.567 0.011,-0.85 0.058,-1.085c0.236,-1.19 1.167,-2.121 2.357,-2.357c0.235,-0.047 0.518,-0.058 1.085,-0.058l15,0c0.567,0 0.85,0.011 1.085,0.058c1.19,0.236 2.121,1.167 2.357,2.357c0.047,0.235 0.058,0.518 0.058,1.085c0,0.567 -0.011,0.85 -0.058,1.085c-0.208,1.048 -0.954,1.895 -1.942,2.244Zm-17.195,-1.848c0.06,0.012 16.33,0.012 16.39,-0c0.397,-0.079 0.707,-0.389 0.786,-0.786c0.03,-0.151 0.019,-0.332 0.019,-0.695c-0,-0.363 0.011,-0.544 -0.019,-0.695c-0.079,-0.397 -0.389,-0.707 -0.786,-0.786c-0.151,-0.03 -16.239,-0.03 -16.39,-0c-0.397,0.079 -0.707,0.389 -0.786,0.786c-0.03,0.151 -0.019,0.332 -0.019,0.695c-0,0.363 -0.011,0.544 0.019,0.695c0.079,0.397 0.389,0.707 0.786,0.786Zm1.195,2.019l-0,7.2c-0,1.436 -0.061,2.159 0.218,2.708c0.192,0.376 0.498,0.682 0.874,0.874c0.548,0.279 1.272,0.218 2.708,0.218l6.4,0c1.436,0 2.16,0.061 2.708,-0.218c0.376,-0.192 0.682,-0.498 0.874,-0.874c0.279,-0.548 0.218,-1.272 0.218,-2.708l-0,-7.2l-14,0Zm5,5c-0.552,-0 -1,-0.448 -1,-1c-0,-0.552 0.448,-1 1,-1l4,-0c0.552,-0 1,0.448 1,1c-0,0.552 -0.448,1 -1,1l-4,-0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBBoxArchive);
export default __webpack_public_path__ + "static/media/iconB-box-archive.7d857d315bdd21bb85682da8cb052a6e.svg";
export { ForwardRef as ReactComponent };